"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = exports.BigArrowLeft = exports.ArrowLeft = exports.ResetLink = exports.LinkAsButtonBig = exports.LinkAsButton = exports.CTALink = exports.LayoutLink = exports.StyledLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("../../assets/svg-components");
exports.StyledLink = styled_components_1.default.a `
  font-weight: ${props => props.theme.typography.weight.medium};
  font-size: ${props => props.theme.typography.size.s3}px;
  line-height: ${props => props.theme.typography.lineHeight.s5}px;
  font-style: normal;

  transition: ${props => props.theme.animations.primary};
  transition-property: color, background;
  border-radius: ${props => props.theme.attributes.borderRadius.xs}px;
  padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.s5}px;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border: none;

  color: ${props => (props.disabled ? props.theme.palette.UI_DISABLED_DETAIL : props.theme.palette.BW_100)};
  stroke: ${props => (props.disabled ? props.theme.palette.UI_DISABLED_DETAIL : props.theme.palette.BW_100)};
  background: ${props => (props.disabled ? props.theme.palette.UI_DISABLED_BACKGROUND : props.theme.palette.BLUE_100)};

  outline-offset: ${props => props.theme.spacing.xs}px;

  &:hover {
    background: ${props => !props.disabled && props.theme.palette.BLUE_GRAY_100};
    border-color: ${props => !props.disabled && 'transparent'};
    cursor: ${props => !props.disabled && 'pointer'};
  }

  &:focus {
    outline: ${props => props.theme.constants.borderWidth.sm}px solid ${props => props.theme.palette.UI_FOCUS_TAB};
  }
`;
exports.LayoutLink = (0, styled_components_1.default)(exports.StyledLink) `
  color: ${props => (props.overImage ? props.theme.palette.BW_100 : props.theme.palette.TYPE_LIGHT_BLACK)};
  background: ${props => { var _a, _b; return (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.BW_100; }};
  border: 1px solid ${props => { var _a, _b; return (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.LIGHT_BLACK; }};
  &:hover {
    color: ${props => !props.disabled && props.theme.palette.BW_100};
    background: ${props => !props.disabled && props.theme.palette.BLUE_100};
  }

  &:focus {
    background: ${props => !props.disabled && props.theme.palette.BW_100};
    color: ${props => !props.disabled && props.theme.palette.TYPE_LIGHT_BLACK};
  }
`;
exports.CTALink = (0, styled_components_1.default)(exports.StyledLink) `
  color: ${props => (props.overImage ? props.theme.palette.BW_100 : props.theme.palette.TYPE_LIGHT_BLACK)};
  background: ${props => props.disabled
    ? props.theme.palette.UI_DISABLED_BACKGROUND
    : props.overImage
        ? props.theme.palette.BLUE_100
        : props.theme.palette.BW_100};
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  &:hover {
    color: ${props => !props.disabled && props.theme.palette.BW_100};
    background: ${props => !props.disabled && props.theme.palette.BLUE_100};
  }

  &:focus {
    background: ${props => !props.disabled && props.theme.palette.BW_100};
    color: ${props => !props.disabled && props.theme.palette.TYPE_LIGHT_BLACK};
  }
`;
exports.LinkAsButton = (0, styled_components_1.default)(exports.StyledLink) `
  color: ${props => props.disabled
    ? props.theme.palette.UI_DISABLED_BACKGROUND
    : props.overImage
        ? props.theme.palette.BW_100
        : props.theme.palette.BLUE_100};
  stroke: ${props => props.disabled
    ? props.theme.palette.UI_DISABLED_BACKGROUND
    : props.overImage
        ? props.theme.palette.BW_100
        : props.theme.palette.BLUE_100};
  line-height: ${props => props.theme.typography.lineHeight.m3}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  transition: ${props => props.theme.animations.primary};
  transition-property: color, text-decoration;
  background: transparent;
  padding: 0;
  margin: 0;
  text-align: left;

  text-decoration: none;

  &:hover {
    color: ${props => (!props.disabled && !props.hoverColor ? props.theme.palette.ORANGE_100 : props.hoverColor)};
    stroke: ${props => (!props.disabled && !props.hoverColor ? props.theme.palette.ORANGE_100 : props.hoverColor)};
    background: transparent;
    border-color: ${props => !props.disabled && props.theme.palette.ORANGE_100};
    text-decoration: ${props => !props.disabled && 'underline'};
  }

  &:focus {
    background: transparent;
    text-decoration: none;
  }
`;
exports.LinkAsButtonBig = (0, styled_components_1.default)(exports.LinkAsButton) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  line-height: ${props => props.theme.typography.lineHeight.m4}px;
  stroke: ${props => props.theme.palette.LIGHT_BLACK};
  background: transparent;
  padding: 0;
  font-weight: ${props => props.theme.typography.weight.light};
  font-size: ${props => props.theme.typography.size.m1}px;

  &:hover,
  &:focus {
    background: transparent;
  }
`;
exports.ResetLink = (0, styled_components_1.default)(exports.LinkAsButton) `
  line-height: ${props => props.theme.typography.lineHeight.s5}px;
`;
exports.ArrowLeft = (0, styled_components_1.default)(svg_components_1.ArrowLeftIcon) `
  transition: ${props => props.theme.animations.primary};
  stroke: inherit;
`;
exports.BigArrowLeft = (0, styled_components_1.default)(svg_components_1.ArrowLeftIcon) `
  transition: ${props => props.theme.animations.primary};
  stroke: inherit;
`;
exports.ButtonContainer = styled_components_1.default.div `
  margin-left: ${props => props.theme.spacing.s3}px;
  flex-shrink: 0;
  display: inline;
`;
exports.default = exports.StyledLink;
